export default "__VITE_ASSET__7d1d9815__"